export default __webpack_public_path__ + "static/media/cover.ef3735a9.jpg";